import { dateService } from "../datetime/time.js";
import { getWeekStartDay } from "../settings/calendar_settings.js";
import { WEEKSTART } from "../util/localization.js";

Date.prototype.addDays = function(days) {
    const date = new Date(this.valueOf());
    date.setDate(date.getDate() + days);
    return date;
};

class Calendar {
    week_start_day; // 0 - monday, 1 - sunday
    direction;
    month_start_date;
    next_month_start_date;

    constructor(week_start_day, direction) {
        this.week_start_day = week_start_day;
        this.direction = direction;
        let today = dateService.getDate();
        let currentMonth = today.getMonth();
        let currentYear = today.getFullYear();
        this.month_start_date = new Date(currentYear, currentMonth);
        this.next_month_start_date = new Date(this.month_start_date).setMonth(this.month_start_date.getMonth() + 1);
    }

    #adjustWeekStart(weekDay) {
        if (this.week_start_day === WEEKSTART.MONDAY) {
            if (weekDay === 0) {
                return -6;
            }
            return weekDay + 1;
        }
        return weekDay;
    }

    #render_day(cell, d) {
        cell.innerHTML = "";
        cell.className = "";
        cell.classList.add("calendar-day"); // Use for styling each day cell

        if (d < this.month_start_date || d >= this.next_month_start_date) {
            cell.textContent = "";  // clear the content of the cell
            cell.classList.add("other-month");
        } else {
            let cellText = document.createTextNode(d.getDate());
            if (d.getDate() === dateService.getDate().getDate() && d.getMonth() === dateService.getDate().getMonth()) {
                let dayDiv = document.createElement("div");
                dayDiv.classList.add("current-day");
                cell.appendChild(dayDiv);
            }
            else if (d < dateService.getDate()) {
                cell.classList.add("past-day");
            }
            if (d.isWeekEnd()) {
                cell.classList.add("holiday");
            }

            let innerDiv = document.createElement("div");
            // marker class for selection
            innerDiv.classList.add("custom-icon");
            let innerSpan = document.createElement("span");
            innerSpan.appendChild(cellText);
            cell.appendChild(innerSpan);
            cell.appendChild(innerDiv);

            // events
            let eventsSpan = document.createElement("span");
            eventsSpan.classList.add("event-dots");
            cell.appendChild(eventsSpan);

            cell.setAttribute('data-day', d.getDate());
        }
    }

    render() {
        let startDate = this.month_start_date.addDays(this.#adjustWeekStart(-this.month_start_date.getDay()));

        // Render week days headers
        const headerCells = document.querySelectorAll(".calendar-header");
        for (let i = 0; i < headerCells.length; i++) {
            let d = new Date(startDate.getTime()).addDays(i);
            headerCells[i].textContent = d.shortWeekday();
        }

        // Render days
        const dayCells = document.querySelectorAll(".calendar-day");
        for (let week = 0; week < 6; week++) {
            let week_start = startDate.addDays(week * 7);
            for (let day = 0; day < 7; day++) {
                let dayIndex = week * 7 + day; // Calculate the day cell index
                if (dayIndex < dayCells.length) {
                    this.#render_day(dayCells[dayIndex], week_start.addDays(day));
                }
            }
        }
    }
}

export function renderCalendar() {
    // creating all cells
    let c;
    if (getWeekStartDay() === "monday") {
        c = new Calendar(WEEKSTART.MONDAY);
    } else if (getWeekStartDay() === "sunday") {
        c = new Calendar(WEEKSTART.SUNDAY);
    }
    c.render();
}
